import Vue from "vue";
//import VueAnalytics from 'vue-analytics';
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import router from "./routes/router";
import "core-js";
import store from "./store";
import ApiService from "./common/api.service";
import {VERIFY_AUTH} from "./store/auth.module";
import Highcharts from "highcharts/highcharts";
import HighchartsVue from "highcharts-vue";
import stockInit from "highcharts/modules/stock";
import VueJsonToCsv from "vue-json-to-csv";
import VueClipboard from "vue-clipboard2";
import ImageUploader from "vue-image-upload-resize";
import IdleVue from "idle-vue";
import LogRocket from "logrocket";
import VueScrollTo from "vue-scrollto";
import VueCountryCode from "vue-country-code";
//if you want to use default color, import this css file
//import hljs from "highlight.js";
//import "vue-hljs/dist/style.css";
//import "vue-hljs/dist/vue-hljs.min.css";
// import "highlight.js/styles/default.css";
// import VueHljs from "vue-hljs";
import {extend, localize, ValidationObserver, ValidationProvider} from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import * as rules from "vee-validate/dist/rules";
import Toast, {POSITION, TYPE} from "vue-toastification";
import "vue-toastification/dist/index.css";
import Transitions from "vue2-transitions";
import {MonthPicker, MonthPickerInput} from "vue-month-picker";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import initService from "./common/api-services/init-service";
//import {version as UX_VERSION} from "../package.json";
import * as defpack from "../package.json";

//import VJsoneditor from 'v-jsoneditor/src/index'
// Manage logrocket plugin
// don't show for localhost or [dev]
if (
	!location.toString().toLowerCase().includes("localhost") &&
	process.env.NODE_ENV.toString().toLowerCase().includes("prod")
) {
	LogRocket.init("7kn92t/dcc-portal");
	//Bugsnag.start("36b5dc8eaaba96fe19d781e36f2c5dae");
}

Object.keys(rules).forEach(rule => {
	extend(rule, rules[rule]);
});

localize("en", en);

// const logrocketPlugin = createPlugin(LogRocket);
// const store = new Vuex.Store({
//   // ...
//   plugins: [logrocketPlugin]
// });

//note: needs "yarn add aws-rum-web"
// //Add AWS RUM App Monitoring
// import {AwsRum, AwsRumConfig} from "aws-rum-web";
// try {
// 	const AwsRumConfig = {
// 		sessionSampleRate: 1,
// 		guestRoleArn: "arn:aws:iam::816799331189:role/RUM-Monitor-us-east-1-816799331189-0788125987561-Unauth",
// 		identityPoolId: "us-east-1:b7ce4b73-fbb1-402c-9113-15bddeaf88c4",
// 		endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
// 		telemetries: ["performance", "errors", "http"],
// 		allowCookies: true,
// 		enableXRay: true,
// 	};
// 	const APPLICATION_ID = "49a7b977-53a3-4891-baa8-81551929a9db";
// 	const APPLICATION_VERSION = "1.0.0";
// 	const APPLICATION_REGION = "us-east-1";
// 	const AwsRum = new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, AwsRumConfig);
// } catch (error) {
// 	// Ignore errors thrown during CloudWatch RUM web client initialization
// }

const eventsHub = new Vue(); //not sure what this is

// // Setup Google Analytics
// Vue.config.productionTip = false;
// // Configuration VueAnalytics
// //https://webdeasy.de/en/vue-analytics-en/
// Vue.use(VueAnalytics, {
// //   id: 'G-N0RZVJ8TKG',
// 	id: 'G-11SBBHC3C1',
// 	router
// });

// Setup dispatcher
ApiService.init();
router.beforeEach((to, from, next) => {
	Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);
	setTimeout(() => {
		window.scrollTo(0, 0);
	}, 100);
});
let VUE_APP_SESSION_TIMEOUT_MINUTES = `${process.env.VUE_APP_SESSION_TIMEOUT_MINUTES}`;
// Vueplugin setup
Vue.use(IdleVue, {
	eventEmitter: eventsHub,
	store,
	idleTime: VUE_APP_SESSION_TIMEOUT_MINUTES * 60000 - 11000, // 15 seconds
	startAtIdle: false,
});
Vue.use(DashboardPlugin);
Vue.use(VueClipboard);
Vue.use(ImageUploader);
stockInit(Highcharts);
Vue.use(HighchartsVue);
Vue.use(VueJsonToCsv);
Vue.use(VueCountryCode);
//Vue.use(VJsoneditor);
//Vue.use(vueHljs, {hljs});
Vue.use(VueScrollTo, {duration: 1000});
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
Vue.use(Transitions);
Vue.use(Toast, {
	transition: "Vue-Toastification__bounce",
	closeOnClick: false,
	maxToasts: 20,
	newestOnTop: true,
	position: POSITION.BOTTOM_RIGHT,
	toastDefaults: {
		[TYPE.ERROR]: {
			timeout: 45000,
		},
		[TYPE.WARNING]: {
			timeout: 10000,
		},
		[TYPE.SUCCESS]: {
			timeout: 5000,
		},
		[TYPE.INFO]: {
			timeout: 5000,
		},
	},
});

// console.log("UX_VERSION: " + UX_VERSION);

// Setup Bugsnag
Bugsnag.start({
	enabledReleaseStages: ["production"],
	plugins: [new BugsnagPluginVue()],
	apiKey: process.env.VUE_APP_BUGSNAG_TOKEN,
	releaseStage: process.env.NODE_ENV,
	appVersion: defpack.version,
	redactedKeys: [
		/^auth$/i, // case-insensitive
		/^key$/i, // case-insensitive: "key", "KEY", "KeY"
		"access_token", // exact match: "access_token"
		/^password$/i, // case-insensitive: "password", "PASSWORD", "PaSsWoRd"
		/^cc_/, // prefix match: "cc_number" "cc_cvv" "cc_expiry"
	],
	onError: function (event) {
		let user = initService.getCustomerUser();
		//configure the bugsnag user identification
		event.setUser("3", user.email, user.username);
		//set the site settings
		event.addMetadata("site-settings", event);
	},
});
Bugsnag.beforeNotify = function (data) {
	if (
		!location.toString().toLowerCase().includes("localhost") &&
		process.env.NODE_ENV.toString().toLowerCase().includes("prod")
	) {
		data.metaData.sessionURL = LogRocket.sessionURL;
	}
	return data;
};
const bugsnagVue = Bugsnag.getPlugin("vue");
bugsnagVue.installVueErrorHandler(Vue);

Vue.use(MonthPicker);
Vue.use(MonthPickerInput);

new Vue({
	el: "#app",
	render: h => h(App),
	router,
	store,
});
